import { Grid, Typography } from '@mui/material'
import ArrowRightIcon from 'assets/icons-orange/arrow-right.svg'

interface Props {
  bf: string
  af?: string
}
const ValueChange = ({ bf, af }: Props) => {
  if (af && bf !== af)
    return (
      <Grid container>
        <Grid item xs={4} textAlign="start">
          <Typography
            variant="body2"
            color="text.primary"
            fontWeight={600}
            whiteSpace="nowrap"
          >
            {bf}
          </Typography>
        </Grid>
        <Grid item xs={4} textAlign="center">
          <img
            src={ArrowRightIcon}
            alt="ArrowRightIcon"
            width={24}
            height={18}
          />
        </Grid>
        <Grid item xs={4} textAlign="end">
          <Typography
            variant="body2"
            color="text.primary"
            fontWeight={600}
            whiteSpace="nowrap"
          >
            {af}
          </Typography>
        </Grid>
      </Grid>
    )
  return (
    <Typography variant="body2" fontWeight={600} color="text.primary">
      {bf}
    </Typography>
  )
}

export default ValueChange
